// extracted by mini-css-extract-plugin
export var actionIcon = "_ry-0";